import { render, staticRenderFns } from "./Fitty.vue?vue&type=template&id=dc85e062&"
import script from "./Fitty.vue?vue&type=script&lang=ts&"
export * from "./Fitty.vue?vue&type=script&lang=ts&"
import style0 from "./Fitty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports